export const LAUNCH_EXPERIENCE_BUTTON_TEXT = 'Launch Experience'
export const LAUNCH_EXPERIENCE_LOADING_TEXT = 'Launching…'
export const LINK_EXPIRES_PREFIX = 'Link expires'
